import { render } from "./ProductVariationList.vue?vue&type=template&id=14882f62&scoped=true&ts=true"
import script from "./ProductVariationList.vue?vue&type=script&lang=ts"
export * from "./ProductVariationList.vue?vue&type=script&lang=ts"

import "./ProductVariationList.vue?vue&type=style&index=0&id=14882f62&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14882f62"]])

export default __exports__